import { WithAbundances } from '@resistapp/common/statistics/resistance-index';
import { ProcessMode } from '@resistapp/common/types';

export function truncateLongString(string: string) {
  return string.length > 10 ? `${string.slice(0, 10)}...` : string;
}

export function get_inRawOrEffluentSamplesString(
  overviewDatum: WithAbundances | undefined,
  processMode: ProcessMode,
  options?: { useSamplingPointName?: boolean },
) {
  if (!overviewDatum) {
    return '';
  }

  if (options?.useSamplingPointName) {
    const datumWithSamplingPoint = overviewDatum as WithAbundances & {
      samplingPoint?: { name?: string };
      samplingPointAfter?: { name?: string };
    };
    const samplingPointName =
      processMode === ProcessMode.AFTER
        ? datumWithSamplingPoint.samplingPointAfter?.name ?? datumWithSamplingPoint.samplingPoint?.name
        : datumWithSamplingPoint.samplingPoint?.name;
    if (samplingPointName) {
      return ` in ${samplingPointName} samples`;
    }
  }

  const mainMetricLabel = processMode === ProcessMode.DURING ? '' : processMode === ProcessMode.BEFORE ? 'raw' : 'treated';
  return mainMetricLabel ? ` in ${mainMetricLabel} samples` : '';
}
